import { AuthPage, AuthProps } from "@refinedev/antd";
import { FC } from "react";
import EnvironmentInfo from "../../../components/EnvironmentInfo";

export const ClaraAuthPage: FC<AuthProps> = (props) => {
  return (
    <>
      <div style={{ height: "50vh" }}>
        <AuthPage
          {...props}
          title={
            <img
              src="/assets/logo.svg"
              alt="Clara Logo"
              style={{ maxWidth: "220px" }}
              onDoubleClick={EnvironmentInfo.show}
            />
          }
        />
      </div>
      <div
        style={{
          color: "rgba(0, 0, 0, 0.45)",
          textAlign: "center",
          fontFamily: '"Source Sans 3"',
          fontSize: "12px",
          fontWeight: 600,
          marginTop: "340px",
        }}
      >
        © Two Next GmbH
      </div>
    </>
  );
};
